'use client';

import {
	VelocityClient,
	isVariant,
	PerpMarketAccount,
} from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useEffect, useState } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityClientIsReady from './useVelocityClientIsReady';

export const getTargetPerpMarketAccount = (
	selectedMarketIndex: number,
	velocityClient: VelocityClient
) => {
	return velocityClient.getPerpMarketAccount(selectedMarketIndex);
};

export const useTargetPerpMarketAccount = (marketId?: MarketId) => {
	const velocityClient = useVelocityStore((s) => s.velocityClient.client);
	const velocityClientIsReady = useVelocityClientIsReady();

	const [marketAccount, setMarketsAccount] = useState<
		PerpMarketAccount | undefined
	>(undefined);

	// Keep markets account in state in sync with blockchain
	useEffect(() => {
		if (
			!marketId ||
			!velocityClientIsReady ||
			!isVariant(marketId.marketType, 'perp') ||
			!velocityClient
		) {
			setMarketsAccount(undefined);
			return;
		}

		setMarketsAccount(
			getTargetPerpMarketAccount(marketId.marketIndex, velocityClient)
		);

		const updateHandler = () => {
			setMarketsAccount(
				getTargetPerpMarketAccount(marketId.marketIndex, velocityClient)
			);
		};

		velocityClient.eventEmitter.on('update', updateHandler);

		return () => {
			//todo
			try {
				velocityClient.eventEmitter.removeListener('update', updateHandler);
			} catch {
				// Do nothing
			}
		};
	}, [velocityClient, velocityClientIsReady, marketId]);

	return marketAccount;
};
